import React from "react";
import { useTranslation } from "react-i18next";
import "./NoData.scss";

const NoData = () => {
  const { t } = useTranslation();

  return <div className="no-data">{t("components.NoData.noData")}</div>;
};

export default NoData;
